import type { DownloadMode } from '../types'

interface ModeToggleProps {
  mode: DownloadMode
  onChange: (mode: DownloadMode) => void
  disabled?: boolean
}

export function ModeToggle({ mode, onChange, disabled }: ModeToggleProps) {
  return (
    <div className="flex bg-white/10 rounded-xl p-1 mb-6">
      <button
        type="button"
        onClick={() => onChange('single')}
        disabled={disabled}
        className={`flex-1 py-2.5 px-4 rounded-lg text-sm font-medium transition-all ${
          mode === 'single'
            ? 'bg-twitter-blue text-white'
            : 'text-white/70 hover:text-white'
        } disabled:opacity-50`}
      >
        Single Video
      </button>
      <button
        type="button"
        onClick={() => onChange('bulk')}
        disabled={disabled}
        className={`flex-1 py-2.5 px-4 rounded-lg text-sm font-medium transition-all ${
          mode === 'bulk'
            ? 'bg-twitter-blue text-white'
            : 'text-white/70 hover:text-white'
        } disabled:opacity-50`}
      >
        Bulk Download
      </button>
    </div>
  )
}
